import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
} from "@chakra-ui/react";
import { Trans } from "@lingui/macro";

const Invoiced = () => (
  <Alert
    alignItems="top"
    gridTemplateColumns="max-content 1fr"
    display="grid"
    status="success"
    variant="top-accent"
  >
    <AlertIcon />
    <div>
      <AlertTitle>
        <Trans>The whole project is invoiced</Trans>
      </AlertTitle>
      <AlertDescription>
        <Trans>All budget items are invoiced.</Trans>
      </AlertDescription>
    </div>
  </Alert>
);

export default Invoiced;
